import React from "react";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import AddTrading from "../trading/AddTrading";

const AddTradingDialog = ({ open, onClose, refresh, category }) => {
  const handleRefresh = () => {
    if (refresh) refresh();
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { backgroundImage: "none" } }}
    >
      <Box
        sx={{
          "& .add-media-card": {
            boxShadow: "none !important",
            border: "none !important",
            background: "transparent !important",
          },
        }}
      >
        <AddTrading refresh={handleRefresh} category={category} />
      </Box>
    </Dialog>
  );
};

export default AddTradingDialog;
